import React, {Component} from 'react';
import { Col, CardHeader, Modal, ModalBody, ModalFooter, TabContent, TabPane, FormGroup, Label, Input, Button } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import TagsInput from 'react-tagsinput'

import Config from '../../config';

import './Editor.css';


const NumberInput = createNumberMask({
 prefix: '',
 suffix: ' €',
 allowNegative: true,
 allowLeadingZeroes: true,
 allowDecimal: true, decimalLimit: 5,
 includeThousandsSeparator: false
});

const VATvalue = {
 '1': 1.21,
 '2': 1.10,
 '3': 1.04,
 '0': 1
};


class ProductEditor extends Component {
 constructor(props) {
  super(props);

  this.setValue = this.setValue.bind(this);
  this.handleTabs = this.handleTabs.bind(this);
  this.handleSave = this.handleSave.bind(this);
  this.handleCodes = this.handleCodes.bind(this);
  this.handleClose = this.handleClose.bind(this);
  
  this.state = {
   activeTab: '1',
   titleTab: 'Datos del producto',
   laddaloading: false,
   errMessage: false,
   failedCodes: [],
   editorMode: false,
   classNames: {
    productName: "form-control",
    productAmount: "form-control",
    productVAT: "form-control",
    productPrice: "form-control",
    productStock: "form-control",
    productCodes: "form-control"
   }
  }
 }

 resetAll() {
  this.setState({
   activeTab: '1',
   titleTab: 'Datos del producto',
   laddaloading: false,
   errMessage: false,
   failedCodes: [],
   editorMode: false,
   product: {
    productID: 0,
    productName: '',
    productAmount: 0,
    productVAT: 1,
    productPrice: 0,
    productStock: 0,
    productCodes: []
   },
   classNames: {
    productName: "form-control",
    productAmount: "form-control",
    productVAT: "form-control",
    productPrice: "form-control",
    productStock: "form-control",
    productCodes: "form-control"
   }
  })
 }

 setValue(e) {
  var newProduct = this.state.product;
  newProduct[e.target.id] = e.target.value;

  switch(e.target.id) {
   case 'productVAT':
    if(typeof this.state.product.productPrice == 'string') {
     newProduct['productAmount'] = (parseFloat(this.state.product.productPrice) / VATvalue[e.target.value]);
    } else {
     newProduct['productPrice'] = (parseFloat(this.state.product.productAmount) * VATvalue[e.target.value]);
    }
   break;

   case 'productAmount':
    var productAmount = parseFloat(e.target.value) ? parseFloat(e.target.value) : 0;
    newProduct['productPrice'] = (productAmount * VATvalue[this.state.product.productVAT]);
    if(newProduct['productAmount'] === '') newProduct['productAmount'] = 0;
   break;

   case 'productPrice':
    var productPrice = parseFloat(e.target.value) ? parseFloat(e.target.value) : 0;
    newProduct['productAmount'] = (productPrice / VATvalue[this.state.product.productVAT]);
    if(newProduct['productPrice'] === '') newProduct['productPrice'] = 0;
   break;
  }

  this.setState({product: newProduct});
 }

 handleTabs(tab) {
  switch(tab) {
   case '1': var title = 'Datos del producto'; break;
  }
  this.setState({titleTab: title, activeTab: tab});
 }

 handleCodes(codes) {
  var newProduct = this.state.product;
  newProduct["productCodes"] = codes;
  this.setState({product: newProduct});
 }

 handleSave() {
  var errorFileds = this.state.classNames;
  Object.keys(errorFileds).map(function(key, index) { errorFileds[key] = errorFileds[key].replace(' border border-danger', ''); });
  this.setState({laddaloading: true, classNames: errorFileds});
  this.props.reqAPI(Config.apiURI+'/api/products/editor', 'POST', this.state.product).then((result) => {
   if(result.success) {
    this.props.onComplete(result.product);
    this.resetAll();
   } else {
    var errorFileds = this.state.classNames;
    result.failed.map((key) => { errorFileds[key] = errorFileds[key] + " border border-danger"; });
    this.setState({
     laddaloading: false,
     errMessage: result.message,
     failedCodes: result.codes ? result.codes : [],
     classNames: errorFileds
    });
   }
  }).catch((error) => {
   console.log(error);
   this.setState({laddaloading: false});
  })
 }

 handleClose() {
  this.props.handleClose();
  this.resetAll();
 }

 componentWillMount() {
  this.resetAll();
 }

 componentWillUpdate() {
  if(this.props.product != null && !this.state.editorMode) {
   this.setState({
    editorMode: true,
    product: {
     productID: parseInt(this.props.product.ID),
     productName: this.props.product.name ? this.props.product.name : '',
     productAmount: (parseFloat(this.props.product.price) / VATvalue[this.props.product.tax]),
     productVAT: parseInt(this.props.product.tax),
     productPrice: parseFloat(this.props.product.price),
     productStock: this.props.product.stock ? parseInt(this.props.product.stock) : 0,
     productCodes: this.props.product.codes ? this.props.product.codes : [],
    }
   });
  }
 }

 render() {
  return (
   <Modal className="modal-lg ModalProduct" isOpen={this.props.open}>
    <CardHeader>
     <i className="fa fa-archive"></i><strong>{this.state.titleTab}</strong>
     <div className="card-actions bg-light">
      <Button disabled={this.state.activeTab !== '1'?false:true} onClick={() => this.handleTabs('1')}><i className="fa fa-cube"></i></Button>
     </div>
    </CardHeader>

    <ModalBody>
     <TabContent activeTab={this.state.activeTab}>

      <TabPane tabId="1">
       <FormGroup>
        <Label htmlFor="street"><strong>Nombre</strong></Label>
        <Input type="text" id="productName" value={this.state.product.productName} onChange={(e) => {this.setValue(e)}} placeholder="Introduce el nombre completo del producto" className={this.state.classNames.productName} />
       </FormGroup>

       <FormGroup row>
        <Col xs="8">
         <FormGroup className="form-group-clean">
          <Label htmlFor="without-vat"><strong>Precio</strong> (Sin IVA)</Label>
          <MaskedInput type="text" id="productAmount" value={this.state.product.productAmount} onChange={(e) => {this.setValue(e)}} mask={NumberInput} className={this.state.classNames.productAmount} />
         </FormGroup>
        </Col>
        <Col xs="4">
         <FormGroup className="form-group-clean">
          <Label htmlFor="vat"><strong>IVA</strong></Label>
          <Input type="select" id="productVAT" value={this.state.product.productVAT}  onChange={(e) => {this.setValue(e)}} className={this.state.classNames.productVAT}>
           {Object.keys(VATvalue).map(function(key) {
            return <option key={key} value={key}>{Math.round((VATvalue[key]*100)-100)}% IVA</option>
           })}
          </Input>
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup row>
        <Col xs="8">
         <FormGroup className="form-group-clean">
          <Label htmlFor="with-vat"><strong>Precio</strong> (Con IVA)</Label>
          <MaskedInput type="text" id="productPrice" value={this.state.product.productPrice} onChange={(e) => {this.setValue(e)}} mask={NumberInput} className={this.state.classNames.productPrice} />
         </FormGroup>
        </Col>
        <Col xs="4">
         <FormGroup className="form-group-clean">
          <Label htmlFor="stock"><strong>Stock</strong></Label>
          <Input type="text" id="productStock" value={this.state.product.productStock} onChange={(e) => {this.setValue(e)}} placeholder="Introduce cantidad disponible" className={this.state.classNames.productStock} />
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup>
        <Label htmlFor="barcodes"><strong>Códigos de barra</strong></Label>
        <TagsInput
         id="productCodes"
         value={this.state.product.productCodes}
         onChange={this.handleCodes}
         onlyUnique={true}
         addOnPaste={true}
         inputProps={{placeholder: "Añadir código"}}
         tagProps={{failed: this.state.failedCodes}}
         renderTag={function defaultRenderTag(props) {
          let {tag, failed, key, disabled, onRemove, getTagDisplayValue} = props
          return (
           <span key={key} className={(failed.indexOf(tag) === -1) ? 'react-tagsinput-tag' : 'react-tagsinput-tag tag-error'}>
            {getTagDisplayValue(tag)}
            {!disabled && <a className="react-tagsinput-remove" onClick={(e) => onRemove(key)} /> }
           </span>
          )
        }}
       />
       </FormGroup>
      </TabPane>

     </TabContent>
    </ModalBody>

    <ModalFooter>
     <div className="text-danger"><strong>{this.state.errMessage}</strong></div>
     <Button color="danger" onClick={this.handleClose}>Cancelar</Button>
     <LaddaButton
      type="submit"
      onClick={this.handleSave}
      className="btn btn-success btn-ladda" 
      data-style={EXPAND_LEFT} 
      loading={this.state.laddaloading}>
      {this.state.editorMode?'Guardar cambios':'Crear producto'}
     </LaddaButton>
    </ModalFooter>
   </Modal>
  )
 }

}

export default ProductEditor;



// WEBPACK FOOTER //
// ./src/components/Product/Editor.js